import type { Sticker } from '../types';

export const forest: Sticker[] = [
  {
    id: 24001,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/001-tree.png',
    name: 'Drzewo',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24002,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/002-bush.png',
    name: 'Krzew',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24003,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/003-beehive.png',
    name: 'Ul',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24004,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/004-gps.png',
    name: 'GPS',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24005,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/005-cooking.png',
    name: 'Gotowanie',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24006,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/006-flower.png',
    name: 'Kwiat',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24007,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/007-hunting.png',
    name: 'Polowanie',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24008,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/008-bird.png',
    name: 'Ptak',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24009,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/009-mushroom.png',
    name: 'Grzyb',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24010,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/010-fishing.png',
    name: 'Wędkowanie',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24011,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/011-forest.png',
    name: 'Las',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24012,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/012-friends.png',
    name: 'Przyjaciele',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24013,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/013-bonfire.png',
    name: 'Ognisko',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24014,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/014-leaf.png',
    name: 'Liść',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24015,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/015-log.png',
    name: 'Kłoda',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24016,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/016-owl.png',
    name: 'Sowa',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24017,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/017-woodcutter.png',
    name: 'Drwal',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24018,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/018-tree.png',
    name: 'Drzewa',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24019,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/019-loupe.png',
    name: 'Lupa',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 24020,
    url: 'https://stickers.nauczniaczek.pl/colections/14619464-forest/png/020-binoculars.png',
    name: 'Lornetka',
    category: 'forest',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];